
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#9B51E0"}}),_c('path',{attrs:{"d":"M17.167 17.083a3.333 3.333 0 010 6.667h-5M13 17.083H8","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.083 15a2.083 2.083 0 100 4.167 2.083 2.083 0 000-4.167zM10.083 21.667a2.083 2.083 0 100 4.166 2.083 2.083 0 000-4.166zM30.268 16.74l3.046 3.047-3.046 3.046M33.314 19.787H23.74","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    